import React from 'react'

import { ChevronDown, ChevronUp } from 'react-feather'
import { Box, Link } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import usePrimaryBannerPreview from 'hooks/usePrimaryBannerPreview'

import styles from './styles'

const BannerPortalRow = () => {
  const { t } = useTranslation()

  const {
    previewTexts,
    privacyPortalEnabled,
    privacyPortalUrl,
    showDescriptionToggle,
    isDescriptionExpanded,
    onToggleDescription,
    isCompact,
  } = usePrimaryBannerPreview()

  const useStyles = styles(isCompact)
  const classes = useStyles()

  if (!privacyPortalEnabled && !showDescriptionToggle) return null

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent={privacyPortalEnabled ? 'space-between' : 'flex-end'}
      width="100%"
    >
      {privacyPortalEnabled && (
        <Link
          href={privacyPortalUrl || '#'}
          variant="body1"
          target="_blank"
          underline="always"
          className={classes.globalTypography}
          noWrap
        >
          {previewTexts.privacyPortal}
        </Link>
      )}
      {showDescriptionToggle && (
        <Link
          component="button"
          type="button"
          underline="always"
          className={classes.seeMoreLink}
          onClick={onToggleDescription}
        >
          {isDescriptionExpanded ? (
            <ChevronUp className={classes.seeMoreIcon} />
          ) : (
            <ChevronDown className={classes.seeMoreIcon} />
          )}
          {isDescriptionExpanded ? t('banner.showLess') : t('banner.showMore')}
        </Link>
      )}
    </Box>
  )
}

export default BannerPortalRow
